class ScrolledToggleElement {
  constructor() {
    this.DOM = {
      body: document.body,
    };
    this.#addEvent();
  }
  #addEvent() {
    document.addEventListener('scroll', this.#scrolled.bind(this), {passive: true});
  }
  #toggle() {
    const offsetTopBefore = window.pageYOffset;
    if(offsetTopBefore > 0) {
      setTimeout( () => {
        const offsetTopAfter = window.pageYOffset;
        if(offsetTopBefore < offsetTopAfter) {
          this.DOM.body.dataset.stateScrollDown = 'true';
        }
        if(offsetTopBefore > offsetTopAfter) {
          this.DOM.body.dataset.stateScrollDown = 'false';
        }
      }, "200")
    }
  }
  #scrolled() {
    const offsetTop = window.pageYOffset;
    if(offsetTop > 0) {
      this.DOM.body.dataset.stateScrollDown = 'true';
    } else {
      this.DOM.body.dataset.stateScrollDown = 'false';
    }
  }
}
export default ScrolledToggleElement;